up.compiler('[confirm-account-deletion]', (element) => {

  const message = 'Zum dauerhaften Löschen deines Accounts, tippe bitte das Wort LÖSCHEN ein.'
  const requiredInput = 'LÖSCHEN'

  function onClick(event) {
    const input = prompt(message)
    const sanitizedInput = (input || '').trim().toUpperCase()
    const expectedInput = requiredInput.trim().toUpperCase()

    if (input === null) {
      alert('Du hast abgebrochen. Dein Account wurde nicht gelöscht.')
      event.preventDefault()
    } else if (sanitizedInput !== expectedInput) {
      alert(`Deine Eingabe war „${sanitizedInput}“ statt „${expectedInput}“. Dein Account wurde nicht gelöscht.`)
      event.preventDefault()
    } else {
      // submit form to delete account
    }
  }

  element.addEventListener('click', onClick)

})
